import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BusComponent from '../../BusComponent';

import VisibilityToggle from '../../form/VisibilityToggle';
import GeoJsonLibraryLegendItem from './GeoJsonLibraryLegendItem';
import AppConfig from '../../../appConfig';
import Toggle from '../../form/Toggle';

class GeoJsonLibraryLegend extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            useClusters: false,
            visible: true,
            clusteringDisabled: true,
            items: [...props.geoJsonLegendMetadata.layers],
        };
    }

    componentDidMount() {
        this.bindGluBusEvents({
            SHOULD_USE_CLUSTERS_RESPONSE: this.onShouldUseClustersResponse,
            POINTS_GEOJSON: this.onPointsFetched,
        });
        // Enable clustering toggle when opening minimized map layers panel
        this.onPointsFetched();
        this.emit('SHOULD_USE_CLUSTERS_REQUEST');
    }

    onShouldUseClustersResponse = ({ useClusters }) => {
        this.setState({ useClusters });
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    // Turn on/off geoJson layer
    onVisibilityToggle = () => {
        const { mapInstanceId } = this.props;
        const { visible } = this.state;

        this.emit('UPDATE_GEO_JSON_LAYER_GROUP_VISIBILITY', {
            visible: !visible,
            mapInstanceId: mapInstanceId,
        });
        this.setState(state => ({
            visible: !state.visible,
        }));
    };

    // Turn on/off geoJson layer clustering
    onClusterToggle = () => {
        const { mapInstanceId } = this.props;
        const { useClusters } = this.state;

        this.emit('MAP_APPLY_GEO_JSON_CLUSTERING_TOGGLE', {
            useClusters: !useClusters,
            mapInstanceId: mapInstanceId,
        });
        this.setState(state => ({
            useClusters: !state.useClusters,
        }));
    };

    // Single layer visibility toggle
    onLayerVisibilityToggle = layerId => {
        const { mapInstanceId, geoJsonLegendMetadata } = this.props;
        const { items } = this.state;

        const newItems = [...items];
        newItems.forEach(el => {
            if (el.layerId === layerId) el.visible = !el.visible;
        });

        this.emit('UPDATE_GEO_JSON_LAYER_VISIBILITY', {
            featurePropertyNameEquivalentToLayerId: geoJsonLegendMetadata.featurePropertyNameEquivalentToLayerId,
            layerVisibility: newItems.map(l => ({ layerId: l.layerId, visible: l.visible })),
            mapInstanceId: mapInstanceId,
        });

        this.setState({
            items: newItems,
        });
    }

    // Clustering button gets enabled only after geoJSON is fetched
    onPointsFetched = () => {
        this.setState({ clusteringDisabled: false });
    };

    render() {
        const { geoJsonLegendMetadata } = this.props;
        const { visible, items, useClusters, clusteringDisabled } = this.state;
        const { title } = geoJsonLegendMetadata;

        const titleClasses = classNames({
            disabled: !visible,
        });
        // The legend metadata can be an empty array
        // In that case do not show anything
        if (items.length === 0) return null;


        return (
            <div className="geo-json-library-legend">
                <div className="geo-json-library-legend__group">
                    <div className="geo-json-library-legend__title">
                        <span className={titleClasses}>{title}</span>
                        <div className="flex-it center">
                            <VisibilityToggle
                                onClick={this.onVisibilityToggle}
                                visible={visible}
                                className="geo-json-library-legend__visibility-toggle"
                                iconClassName='material-icons-outlined'
                            />
                        </div>
                    </div>
                    {visible && (
                    <div className="geo-json-library-legend__items">
                        {items.map(item => (
                            <GeoJsonLibraryLegendItem
                                key={item.layerId}
                                item={item}
                                iconSize={24}
                                onLayerVisibilityToggle={this.onLayerVisibilityToggle}
                            />
                            ))
                        }
                        { AppConfig.constants.shouldShowPointClusterToggle &&
                        <div className="geo-json-library-legend__item">
                            <div className="layer-library-classes__item-icon layer-library-classes__item-icon--svg">
                                <img
                                    src={`${AppConfig.constants.assetsBaseURL}/svg/cluster.svg`}
                                    width={24}
                                    height={24}
                                    alt="Cluster toggle icon"
                                />
                            </div>
                            <span className="layer-library-classes__item-label">Clustering</span>
                            <Toggle
                                className="cluster-toggle"
                                checked={useClusters}
                                onChange={this.onClusterToggle}
                                disabled={clusteringDisabled} />
                        </div>
                        }
                    </div>
                )}
                </div>
            </div>
        );
    }
}

GeoJsonLibraryLegend.propTypes = {
    geoJsonLegendMetadata: PropTypes.object.isRequired,
    mapInstanceId: PropTypes.string.isRequired,
};

export default GeoJsonLibraryLegend;
